import Dispatcher from "../dispatcher";

const FractionStore = {
  _state: {
    "scrubber-open": true
  },

  // get the state of fraction
  get() {
    return this._state;
  },

  _updateState(state) {
    this._state = $.extend(this._state, state);
    Dispatcher.emit(Dispatcher.FRACTION_STORE_CHANGE);
  },

  init() {
    Dispatcher.setMaxListeners(Dispatcher.getMaxListeners() + 13);

    Dispatcher.bind(Dispatcher.NOTES_DOWN, () => {
      if (!this.get()["notes-down"]) {
        this._updateState({ "notes-down": true });
      }
    });
    Dispatcher.bind(Dispatcher.NOTES_UP, () => {
      if (this.get()["notes-down"]) {
        this._updateState({ "notes-down": false });
      }
    });
    Dispatcher.bind(Dispatcher.LICENSE_UPDATED, () => {
      this._updateState({ "license-updating": false });
    });
    Dispatcher.bind(Dispatcher.LICENSE_UPDATING, () => {
      this._updateState({ "license-updating": true });
    });
    Dispatcher.bind(Dispatcher.POPOVER_OPEN, () => {
      this._updateState({ "popover-open": true });
    });
    Dispatcher.bind(Dispatcher.POPOVER_CLOSE, () => {
      this._updateState({ "popover-open": false });
    });
    Dispatcher.bind(Dispatcher.MODAL_OPEN, () => {
      this._updateState({ "modal-open": true });
    });
    Dispatcher.bind(Dispatcher.MODAL_CLOSE, () => {
      this._updateState({ "modal-open": false });
    });
    Dispatcher.bind(Dispatcher.MAIN_MENU_OPEN, () => {
      this._updateState({ "main-menu-open": true });
    });
    Dispatcher.bind(Dispatcher.MAIN_MENU_CLOSE, () => {
      this._updateState({ "main-menu-open": false });
    });
    Dispatcher.bind(Dispatcher.SCRUBBER_OPEN, () => {
      this._updateState({ "scrubber-open": true });
    });
    Dispatcher.bind(Dispatcher.SCRUBBER_CLOSE, () => {
      this._updateState({ "scrubber-open": false });
    });
    Dispatcher.bind(Dispatcher.UPDATE_FRACTION_STORE, data => {
      this._updateState(data);
    });
  }
};

FractionStore.init();

export default FractionStore;
